<nav mat-tab-nav-bar>
  <div mat-tab-link
     *ngFor="let tab of tabsConfig"
     [routerLink]="tab.route"
     on
     routerLinkActive #rla="routerLinkActive"
     [active]="rla.isActive">
    {{tab.key | translate}}
  </div>
</nav>
